
export function hasProject(
    lineItems: any[]
): boolean {

    return lineItems.some(
        lineItem => Boolean(lineItem.custom)
    );
}
export function hasFavorites(
    lineItems: any[]
): boolean {

    return lineItems.some(
        lineItem => Boolean(!lineItem.custom)
    );

}